<saf-list-view [listName]="listName">
  <div class="container" fxLayout="column" fxLayoutGap="16px" fxLayoutGap.xs="8px">
    <section class="header" fxLayout="row" fxLayoutGap="16px" fxLayoutGap.xs="8px">
      <button class="schooling" mat-raised-button color="primary" (click)="openTuitionDetails($event)">
        <mat-icon>add</mat-icon>
        <span>{{ 'add' | translate }}</span>
      </button>
      <button class="schooling" mat-raised-button type="button" color="primary"
        (click)="openExportPage()">
        <mat-icon fontSet="material-symbols-outlined">download</mat-icon>
        <span>{{ 'export' | translate }}</span>
      </button>
      <button class="schooling" mat-raised-button type="button" color="primary" (click)="openTableColumnDialog()">
        <mat-icon fontSet="material-symbols-outlined">pivot_table_chart</mat-icon>
        <span>{{ 'editTable' | translate }}</span>
      </button>

      <saf-filter-panel id="filterPanel" [placeholder]="('enterSearchTermTopic' | translate)"
      (filterChange)="applyDrawerFilters($event)" [listName]="listName" ></saf-filter-panel>
      <button [matTooltip]="'showMoreFilters' | translate" mat-mini-fab id="filterButton" class="schooling" color="primary" (click)="listView.toggleDrawer()"
        [matBadge]="filterLength(listName)" matBadgeColor="warn" [matBadgeHidden]="filterLength(listName) === 0">
        <mat-icon>filter_list</mat-icon>
      </button>
    </section>
    <mat-card appearance="outlined" class="content">

      <div class="table-container" [fxShow]="dataSource.data.length">
        <table mat-table [dataSource]="dataSource" id="table" class="table" matSort matSortDirection="desc" matSortActive="createDate" [trackBy]="trackById"
               [safResizableColumns]="listName">
          <ng-container matColumnDef="topicName">
            <th mat-header-cell matTooltip="{{ 'topic' | translate }}" *matHeaderCellDef disableClear mat-sort-header="topicName">{{ 'topicShort' | translate }}</th>
            <td mat-cell *matCellDef="let listItem">
              <span >{{ listItem.topic.name }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="tuitionTime">
            <th mat-header-cell *matHeaderCellDef>
              <span>{{ 'tuitionTimeShort' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem">
              <span style="font-weight:{{listItem.tuition.tuitionTime === '00:00:00' ? 'bold' : ''}}">{{ listItem.tuition.tuitionTime === '00:00:00' ? ('noTime' | translate) : (listItem.tuition.tuitionTime | time) }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="creator">
            <th mat-header-cell *matHeaderCellDef>
              <span matTooltip="{{ 'creator' | translate }}">{{ 'creatorShort' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem">
              <saf-employee-name [firstName]="listItem.assigneeEmployee.firstName"
                                 [lastName]="listItem.assigneeEmployee.name"></saf-employee-name>
            </td>
          </ng-container>

          <ng-container matColumnDef="tuitionLocation">
            <th mat-header-cell *matHeaderCellDef>
              <span matTooltip="{{ 'location' | translate }}">{{ 'locationShort' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem">
              <span [class]="listItem.location ? '' : 'saf-chip'">{{ listItem.location ? listItem.location.name : '-'  }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="tuitionRoom">
            <th mat-header-cell *matHeaderCellDef>
              <span matTooltip="{{ 'room' | translate }}">{{ 'roomShort' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem">
              <span [class]="listItem.room ? '' : 'saf-chip'">{{ listItem.room ? listItem.room.name : '-'  }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="lectureName">
            <th mat-header-cell *matHeaderCellDef>
              <span matTooltip="{{ 'lecturerEmployee' | translate }}">{{ 'lecturerEmployeeShort' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem">
              @if (listItem.lecturerEmployee) {
                <saf-employee-name [firstName]="listItem.lecturerEmployee.firstName"
                                   [lastName]="listItem.lecturerEmployee.name"></saf-employee-name>

              } @else {
                <span class="saf-chip" style="font-weight: bold">{{'noLecturer' | translate}}</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="externalLecturerName">
            <th mat-header-cell *matHeaderCellDef>
              <span matTooltip="{{ 'externalLecturerName' | translate }}">{{ 'externalLecturerNameShort' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem">
            @if (listItem.externalLecturer) {
              <saf-employee-name [firstName]="listItem.externalLecturer.firstName"
                                 [lastName]="listItem.externalLecturer.name"></saf-employee-name>
            } @else {
              <span class="saf-chip" style="font-weight: bold">{{'noLecturer' | translate}}</span>
            }
            </td>
          </ng-container>

          <ng-container matColumnDef="externalCompany">
            <th mat-header-cell *matHeaderCellDef>
              <span matTooltip="{{ 'externalCompany' | translate }}">{{ 'externalCompanyShort' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem">
            @if (listItem.externalCompany) {
              <span>{{ listItem.externalCompany.name }}</span>
            } @else {
              <span class="saf-chip">{{ '-' }}</span>
            }
            </td>
          </ng-container>

          <ng-container matColumnDef="tuitionDate">
            <th mat-header-cell *matHeaderCellDef>
              <span matTooltip="{{ 'tuitionDate' | translate }}">{{ 'tuitionDateShort' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem">
              <span style="font-weight:{{listItem.tuition.tuitionDate ? '' : 'bold'}}">{{ listItem.tuition.tuitionDate  ?
              (listItem.tuition.tuitionDate | date) : ('noDate' | translate )}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
              <span matTooltip="{{ 'topicAssignmentStatus' | translate }}">{{ 'topicAssignmentStatus' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem">
              @switch (listItem.tuition.status) {
                @case (0) {
                  <div class="status-color {{checkDate(listItem)? 'yellow' : 'red'}}" matTooltip="{{ (checkDate(listItem)? 'openTuition' : 'overdueTuition') | translate }}"></div>
                }
                @case (1) {
                  <div class="status-color green" matTooltip="{{ 'completedTuition' | translate }}"></div>
                }
                @case (2) {
                  <div class="status-color violet" matTooltip="{{ 'canceledTuition' | translate }}"></div>
                }
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="participantsInfo">
            <th mat-header-cell *matHeaderCellDef>
              <span matTooltip="{{ 'signedParticipants' | translate }}">{{ 'signedParticipantsShort' | translate }}</span>
            </th>
            <td mat-cell *matCellDef="let listItem" (click)="openParticipantList($event, listItem)">
              <span>{{ getParticipantInfo(listItem) }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="createDate" >
            <th mat-header-cell matTooltip="{{ 'createDate' | translate }}" *matHeaderCellDef disableClear mat-sort-header="createDate">{{ 'createDateShort' | translate }}</th>
            <td mat-cell *matCellDef="let listItem">
              <span>{{ listItem.tuition.createDate  ?
                (listItem.tuition.createDate | date) : ('noDate' | translate )}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="finish" >
            <th mat-header-cell matTooltip="{{ 'finish' | translate }}" *matHeaderCellDef>{{ 'finish' | translate }}</th>
            <td mat-cell *matCellDef="let listItem">
              @if (listItem.tuition.status === 0) {
                <button mat-icon-button (click)="finish($event, listItem.tuition)"
                  matTooltip="{{(listItem.requiredField? 'finish' : 'returnRequiredFieldErrorTuition') | translate }}">
                  <mat-icon [class]="listItem.requiredField ? 'isCheckIcon' : 'isClearIcon'">check</mat-icon>
                </button>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef>{{ 'options' | translate }}</th>
            <td mat-cell *matCellDef="let listItem">
              <button mat-icon-button (click)="openFileList($event, listItem)" matTooltip="{{ 'fileAttachments' | translate }}">
                <mat-icon class="printIcon">download</mat-icon>
              </button>
              <button mat-icon-button (click)="openPrint($event, listItem)" matTooltip="{{ 'printTuition' | translate }}">
                <mat-icon class="printIcon">print</mat-icon>
              </button>
              <button mat-icon-button (click)="openTuitionDetails($event,listItem)"
                matTooltip="{{ 'edit' | translate }}">
                <mat-icon class="editIcon">edit</mat-icon>
              </button>
              <button [disabled]="listItem.tuition.status === 1" mat-icon-button (click)="openDeleteDialog($event, listItem)"
                matTooltip="{{ (listItem.tuition.status === 1  ? 'notDeletable' : 'delete') | translate }}">
                <mat-icon class="{{listItem.tuition.status === 1? 'disabledIcon' : 'deleteIcon'}}">delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
          <tr mat-row class="selectable" *matRowDef="let row; columns: tableColumns;"
          (click)="openTuitionDetails($event, row)"></tr>
        </table>
        <mat-paginator class="mat-paginator-sticky" style="left: 0" [pageSize]="checkPageSize()" [pageSizeOptions]="pageSizeOptions"
        [length]="totalCount" [showFirstLastButtons]="true" (page)="pageChange($event)"></mat-paginator>
      </div>
      @if (!dataSource.data.length && !loading) {
        <saf-empty-message (reloadClicked)="reloadTable()"></saf-empty-message>
      }
    </mat-card>
  </div>

  <saf-filter-drawer [moduleClass]="'schooling'" (filterChange)="applyDrawerFilters($event)" (drawerClose)="listView.toggleDrawer()" [listName]="listName">
    <saf-topic-filter [listName]="listName"></saf-topic-filter>
    <saf-employee-filter [listName]="listName" [filterParam]="'lecturerId'" [placeholder]="'lecturerEmployee' | translate"></saf-employee-filter>
    <saf-external-company-employee-filter [listName]="listName" [filterParam]="'externalLecturerId'" [placeholder]="'externalLecturer' | translate"></saf-external-company-employee-filter>
    <saf-employee-filter [listName]="listName" [filterParam]="'participantEmployeeId'" [placeholder]="'participant' | translate"></saf-employee-filter>
    <saf-default-enum-filter [listName]="listName" [filterParam]="'statusText'" [placeholder]="'topicAssignmentStatus'"
                             [showIcon]="true" [options]="statusFilterOptions"></saf-default-enum-filter>
    <!--    <saf-department-filter [listName]="listName" [filterParam]="'organiserCompanyId'"></saf-department-filter>-->
  </saf-filter-drawer>
</saf-list-view>
